"use client";
import ContentCard from './ContentCard'

const Usecase = () => {
	return (
		<section id="about" className="container mx-auto pt-16 md:pt-20 lg:pt-2">
			<div className="mb-8 text-center">
				<h2 className="text-2xl font-bold leading-tight text-black dark:text-white sm:text-3xl sm:leading-tight">
					Spanda is designed to meet the needs of various medical fraternity
					stakeholders and the healthcare system.
				</h2>
				<hr className="my-10 border-t border-gray-300 dark:border-gray-700" />
			</div>

			<div className="flex flex-col md:flex-row md:justify-center">
				<style jsx>{`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}</style>
				<ContentCard
					imageSrc="/images/blog/hearuncle1.jpg"
					altText="Image Description"
					imageWidth={290}
					imageHeight={290}
					title="Hearing-Profile"
					description="Spanda provides excellent solutions to age-related hearing loss with:"
					listItems={[
						'Hearing Acuity Personalization (HAP)',
						'Dual Band Amplification (DBA)',
						'In-built Dynamic Noise Filtering (DNF)',
					]}
				/>

				<ContentCard
					imageSrc="/images/blog/diagno3.jpg"
					altText="Diagnosis Image"
					imageWidth={300}
					imageHeight={300}
					title="Diagnosis"
					description="Now diagnose with confidence by narrowing down to a sound of interest with :"
					listItems={[
						"Mode selection",
						"Point of Interest"
					]}
				/>

				<ContentCard
					imageSrc="/images/blog/telemed2.jpg"
					altText="Telemedicine Image"
					imageWidth={274}
					imageHeight={274}
					title="Tele-Medicine"
					description="With Spanda,you can :"
					listItems={[
						"Record",
						"Share",
						"Live Stream",

					]}
				/>
			</div >
			{/* next section  */}
			< div className="flex flex-col md:flex-row md:justify-center" >
				<ContentCard
					imageSrc="/images/blog/students.jpg"
					altText="Students Image"
					imageWidth={290}
					imageHeight={290}
					title="Students"
					description="Now learn and explore :"
					listItems={[
						"New generation digital technologies",
						"Full potential of auscultation",

					]}
				/>
				<ContentCard
					imageSrc="/images/blog/vetinary.jpg"
					altText="Veterinary Image"
					imageWidth={300}
					imageHeight={300}
					title="Veterinary"
					description="More flexibility while auscultating on :"
					listItems={[
						"Speechless",
						"Non-cooperative",
						"Fur skinned"

					]}
				/>
				<ContentCard
					imageSrc="/images/blog/paramed.jpg"
					altText="ParaMedical Image"
					imageWidth={310}
					imageHeight={310}
					title="ParaMedical-Staff"
					description="Backbone of patient care like paramedical staff are empowered :"
					listItems={[
						"Sound clarity",
						"Recording and sharing",
						"Live streaming"

					]}
				/>
			</div >

			< div className="flex flex-col md:flex-row md:justify-center" >
				{/*next section*/}
				<ContentCard
					imageSrc="/images/blog/education.jpg"
					altText="Eductaion Image"
					imageWidth={310}
					imageHeight={310}
					title="Education"
					description="Training with wider audience becomes more effective with ability to :"
					listItems={[
						"Broadcast to multiple listeners",
						"Play it on high fidelity speakers",
						"Create digital library of annotated sound"

					]}
				/>

			</div>
		</section >
	);
};

export default Usecase;
